import React from "react";
import { PageHero, CTA } from "@/components/PageHero";
import { BookOpen, FileText, Briefcase, HelpCircle, Shield, ScrollText, ArrowRight } from "lucide-react";

const RESOURCES = [
  { icon: BookOpen, t: "Blog", d: "Latest articles on tech, business and industry trends." },
  { icon: FileText, t: "Whitepapers", d: "Deep dives into digital transformation topics." },
  { icon: Briefcase, t: "Careers", d: "Join our growing team of technology experts." },
  { icon: HelpCircle, t: "FAQs", d: "Common questions about our services and process." },
  { icon: Shield, t: "Privacy Policy", d: "How we handle and protect your data." },
  { icon: ScrollText, t: "Terms & Conditions", d: "Our service agreement and terms of use." },
];

import { useSEO } from "@/hooks/useSEO";

export default function Resources() {
  useSEO({
    title: "Resources — Blog, Careers & Whitepapers | Easyworks Industries",
    description: "Explore Easyworks resources — blog articles, whitepapers, careers, FAQs and policies from our team of technology experts.",
  });
  return (
    <div data-testid="resources-page">
      <PageHero title="Resources" subtitle="Learn, explore and grow with Easyworks — blog posts, whitepapers, careers and policies." />
      <section className="py-20">
        <div className="container mx-auto max-w-7xl px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {RESOURCES.map((r, i) => {
            const Icon = r.icon;
            return (
              <div key={i} className="p-6 rounded-xl border border-slate-200 hover:border-blue-200 hover:shadow-md hover:-translate-y-1 transition-all cursor-pointer group" data-testid={`resource-${i}`}>
                <div className="w-11 h-11 rounded-md bg-blue-50 flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-[#2563EB]" />
                </div>
                <div className="font-semibold text-slate-900 mb-1.5" style={{ fontFamily: "Outfit" }}>{r.t}</div>
                <p className="text-[13px] text-slate-500 leading-relaxed mb-3">{r.d}</p>
                <div className="text-[13px] font-semibold text-[#2563EB] inline-flex items-center gap-1 group-hover:gap-2 transition-all">Explore <ArrowRight className="w-3.5 h-3.5" /></div>
              </div>
            );
          })}
        </div>
      </section>
      <CTA />
    </div>
  );
}
